// removed by extract-text-webpack-plugin
module.exports = {"root":"_351Ye","label":"_1ipwX","hideInput":"_1ix_F"};


//////////////////
// WEBPACK FOOTER
// ../source/components/Search/styles.css
// module id = 1282
// module chunks = 6 7 8 10